<template>
  <div class="ui form">
    <!-- <h4 class="ui dividing header">{{ $t("date format") }}</h4> -->
    <div class="three fields">
      <div class="field">
        <label for="">{{ $t("simple date format") }} </label>
        <input
          type="text"
          name="simple_date_format"
          v-model="settings.simple_date_format"
        />
      </div>
      <div class="field">
        <label for="">{{ $t("detailed date format") }} </label>
        <input
          type="text"
          name="detailed_date_format"
          v-model="settings.detailed_date_format"
        />
      </div>
      <div class="six column wide field">
        <label for="">{{ $t("second detailed date format") }} </label>
        <input
          type="text"
          name="second_detailed_date_format"
          v-model="settings.second_detailed_date_format"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateFormatManagement",
  components: {},
  computed: {},
  props: { settings: Object },
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
